<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">会員番号</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ member_no }}</div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                        <span class="pr-2">現在のパスワード</span>
                        <span class="badge bg-danger text-white badge-required">※必須</span>
                    </label>
                    <div class="col-sm-9">
                        <input
                            id="currentPassword"
                            type="password"
                            :class="{'is-invalid': valid.currentPassword}"
                            class="form-control"
                            v-model="currentPassword"
                            placeholder="半角英数字8文字以上"
                            @blur="checkInputData"
                            @input="checkInputData"
                        >
                        <div class="invalid-feedback" v-if="valid.currentPassword">{{ valid_message.currentPassword }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                        <span class="pr-2">新しいパスワード</span>
                        <span class="badge bg-danger text-white badge-required">※必須</span>
                    </label>
                    <div class="col-sm-9">
                        <input
                            id="newPassword"
                            type="password"
                            :class="{'is-invalid': valid.newPassword}"
                            class="form-control"
                            v-model="newPassword"
                            placeholder="半角英数字8文字以上"
                            @blur="checkInputData"
                            @input="checkInputData"
                        >
                        <div class="invalid-feedback" v-if="valid.newPassword">{{ valid_message.newPassword }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                        <span class="pr-2">新しいパスワード<br class="mail-confirm-br">（確認）</span>
                        <span class="badge bg-danger text-white badge-required">※必須</span>
                    </label>
                    <div class="col-sm-9">
                        <input
                            id="newRePassword"
                            type="password"
                            :class="{'is-invalid': valid.newRePassword}"
                            class="form-control"
                            v-model="newRePassword"
                            placeholder="半角英数字8文字以上"
                            @blur="checkInputData"
                            @input="checkInputData"
                        >
                        <div class="invalid-feedback" v-if="valid.newRePassword">{{ valid_message.newRePassword }}</div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row justify-content-center flex-column flex-sm-row px-3">
                        <button
                            type="button"
                            class="bluebackbutton mb-2 col-lg-btn-size"
                            @click="submitChangePassword"
                            :disabled="submit_disabled"
                            >
                                パスワードを変更する
                        </button>
                        <button
                            type="button"
                            class="mypagebackbutton mb-2 ml-0 ml-sm-5 col-lg-btn-size"
                            @click="gotoMypageInfo"
                            >戻る
                        </button>
                    </div>
                </div>
                <ConfirmDialog
                    v-if="confirmDialogSw === true && btnUse"
                    initialMessage=""
                    doing=""
                    notDoing=""
                    :close="btnName"
                    :processing="processing"
                    @closeBtn="onSignupForm"
                />
                <div class="mb-3 mypage-gray-border-bottom"></div>
                <div id="overlay" v-if="confirmDialogSw === true && !btnUse">
                    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
                        <div>
                            <div class="confirm_header">
                            パスワードの変更完了
                            </div>
                            <div class='confirmDialog'>
                                <!-- 処理後の表示 -->
                                <div class="dialogContainer" v-if="processing.result !== ''">
                                    <div class="confirm_table">
                                        <div class="confirm_wording">
                                            <p class="text-left mb-4">パスワードの変更が完了しました。</p>
                                            <p class="text-left mb-4" v-if="info_flag">アプリにてログアウト後、新しいパスワードで再度ログインしてください。<br></p>
                                            <p class="text-left mb-4" v-else>メールが届かない場合は下記までお問合せください。<br>{{ info_mail }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group col-sm-12" v-if="!btnUse">
                    <div class="row">
                        <label class="col-sm-12 col-form-label text-danger">※パスワードを忘れた方</label>
                    </div>
                    <div class="row">
                        <label class="col-sm-12 col-form-label">ご登録のメールアドレスにパスワード再設定のメールを送信します。</label>
                    </div>
                    <div class="row">
                        <label class="col-sm-3 col-form-label">登録メールアドレス</label>
                        <label class="col-sm-6 col-form-label">{{ mailReset }}</label>
                        <button
                            type="button"
                            class="bluebackbutton mb-2 col-lg-btn-size"
                            @click="resettingPassBtn"
                            >
                                メールを送信する
                        </button>
                    </div>
                </div>
                <div id="overlay" v-if="mailSendDialogSw === true && !btnUse">
                    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
                        <div>
                            <div class="confirm_header">
                            パスワード再設定のメール
                            </div>
                            <div class='confirmDialog'>
                                <!-- 処理後の表示 -->
                                <div class="dialogContainer" v-if="err_msg !== ''">
                                    <div class="confirm_table">
                                        <div class="confirm_wording">
                                            <p class="text-left mb-4">{{ err_msg }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="dialogContainer" v-else>
                                    <div class="confirm_table">
                                        <div class="confirm_wording">
                                            <p class="text-left mb-4">ご登録のメールアドレスにパスワード再設定のメールを送信しました。<br></p>
                                            <p class="text-left mb-4" v-if="info_flag">パスワードを再設定し、アプリにてログアウト後、新しいパスワードで再度ログインしてください。<br></p>
                                            <p class="text-left mb-4">メールが届かない場合は下記までお問合せください。<br>{{ info_mail }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import { GET_MEMBER_ID, FORGOT_PASSWORD_MAIL } from '../../constants/signin.js';
import { GET_MEMBER } from '../../constants/mypage_info';
import { UPDATE_MYPAGE_PASSWORD } from '../../constants/mypage_pass_change';
import { memberStatusMixin } from './memberStatusMixin';
import Card from '../components/Card';
import MypageHeader from './MypageHeader';
import validater from '../../lib/validater';
import MypageSideMenu from './MypageSideMenu';
import ConfirmDialog from '../components/ConfirmDialog';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        validater,
        Card,
        ConfirmDialog
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: 'パスワード変更',
            member_no: null,
            full_name: null,
            familyName: '',
            givenName: '',
            mailReset: '',
            mailSendDialogSw: false,
            err_msg: '',
            currentPassword: '',
            newPassword: '',
            newRePassword: '',
            submit_disabled: true,
            valid: {
                currentPassword: false,
                newPassword: false,
                newRePassword: false
            },
            valid_message: {
                currentPassword: '',
                newPassword: '',
                newRePassword: ''
            },
            confirmDialogSw: false,
            // 処理の結果のオブジェクト
            processing: {
                result: '1',
                resultText: 'パスワードの変更が完了しました。',
                btnDisabled: 0,
            },
            btnUse: false,
            btnName: '',
            info_flag: process.env.MIX_STYLE_NAME == 'hcgc' ? true: false,
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            this.GetLoginUserMemberStatus();
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            this.familyName = this.$store.state.auth.loginMember.family_name;
            this.givenName = this.$store.state.auth.loginMember.given_name;
            this.mailReset = this.$store.state.auth.loginMember.email;
            if (process.env.MIX_APP_URL) {
                this.btnUse = false;
                this.btnName = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnName = 'ログインページに戻る';
            }
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event){
            if (event.type == "click") {
                if (!this.currentPassword) {
                    this.valid_message.currentPassword = this.$t("error.validation.required.currentPassword");
                    this.valid.currentPassword = true;
                }
                if (!this.newPassword) {
                    this.valid_message.newPassword = this.$t("error.validation.required.newPassword");
                    this.valid.newPassword = true;
                }
                if (!this.newRePassword) {
                    this.valid_message.newRePassword = this.$t("error.validation.required.newRePassword");
                    this.valid.newRePassword = true;
                }
                // エラー状況をチェック
                if (!this.valid.currentPassword &&
                    !this.valid.newPassword &&
                    !this.valid.newRePassword)
                {
                    return true
                }
                return false
            } else if (event.type === 'blur') {
                if (!event.target.value) {
                    if (event.target.id === "currentPassword") {
                        this.valid_message.currentPassword = this.$t("error.validation.required.currentPassword");
                        this.valid.currentPassword = true;
                    } else if (event.target.id === "newPassword") {
                        this.valid_message.newPassword = this.$t("error.validation.required.newPassword");
                        this.valid.newPassword = true;
                    } else if (event.target.id === "newRePassword") {
                        this.valid_message.newRePassword = this.$t("error.validation.required.newRePassword");
                        this.valid.newRePassword = true;
                    }
                } else {
                    if (event.target.id === "currentPassword") {
                        // 現在のパスワードチェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.currentPassword = this.$t("error.validation.length.currentPasswordMax");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.currentPassword = this.$t("error.validation.length.currentPasswordMin");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkStringType(this.currentPassword)) {
                            this.valid_message.currentPassword = this.$t("error.validation.stringtype");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkComplexity(this.currentPassword)) {
                            this.valid_message.currentPassword = this.$t("error.validation.complexity");
                            this.valid.currentPassword = true;
                        } else {
                            // DB登録済みのパスワードとの比較を用意別途用意

                            this.valid_message.currentPassword = "";
                            this.valid.currentPassword = false;
                        }
                    } else if (event.target.id === "newPassword") {
                        // 新しいパスワードチェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.newPassword = this.$t("error.validation.length.newPasswordMax");
                            this.valid.newPassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.newPassword = this.$t("error.validation.length.newPasswordMin");
                            this.valid.newPassword = true;
                        } else if (!validater.checkStringType(this.newPassword)) {
                            this.valid_message.newPassword = this.$t("error.validation.stringtype");
                            this.valid.newPassword = true;
                        } else if (!validater.checkComplexity(this.newPassword)) {
                            this.valid_message.newPassword = this.$t("error.validation.complexity");
                            this.valid.newPassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.newPassword && this.newRePassword) {
                                if (this.newPassword !== this.newRePassword) {
                                    this.valid_message.newPassword = this.$t("error.validation.unmatchPassword");
                                    this.valid.newPassword = true;
                                } else {
                                    this.valid_message.newPassword = "";
                                    this.valid.newPassword = false;
                                    this.valid_message.newRePassword = "";
                                    this.valid.newRePassword = false;
                                }
                            } else {
                                this.valid_message.newPassword = "";
                                this.valid.newPassword = false;
                            }
                        }
                    } else if (event.target.id === "newRePassword") {
                        // 新しいパスワード（確認）チェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.newRePassword = this.$t("error.validation.length.newRePasswordMax");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.newRePassword = this.$t("error.validation.length.newRePasswordMin");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkStringType(this.newRePassword)) {
                            this.valid_message.newRePassword = this.$t("error.validation.stringtype");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkComplexity(this.newRePassword)) {
                            this.valid_message.newRePassword = this.$t("error.validation.complexity");
                            this.valid.newRePassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.newPassword && this.newRePassword) {
                                if (this.newPassword !== this.newRePassword) {
                                    this.valid_message.newRePassword = this.$t("error.validation.unmatchPassword");
                                    this.valid.newRePassword = true;
                                } else {
                                    this.valid_message.newPassword = "";
                                    this.valid.newPassword = false;
                                    this.valid_message.newRePassword = "";
                                    this.valid.newRePassword = false;
                                }
                            } else {
                                this.valid_message.newRePassword = "";
                                this.valid.newRePassword = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            } else {
                if (event.target.value) {
                    if (event.target.id === "currentPassword") {
                        // 現在のパスワードチェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.currentPassword = this.$t("error.validation.length.currentPasswordMax");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.currentPassword = this.$t("error.validation.length.currentPasswordMin");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkStringType(this.currentPassword)) {
                            this.valid_message.currentPassword = this.$t("error.validation.stringtype");
                            this.valid.currentPassword = true;
                        } else if (!validater.checkComplexity(this.currentPassword)) {
                            this.valid_message.currentPassword = this.$t("error.validation.complexity");
                            this.valid.currentPassword = true;
                        } else {
                            // DB登録済みのパスワードとの比較を用意別途用意

                            this.valid_message.currentPassword = "";
                            this.valid.currentPassword = false;
                        }
                    } else if (event.target.id === "newPassword") {
                        // 新しいパスワードチェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.newPassword = this.$t("error.validation.length.newPasswordMax");
                            this.valid.newPassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.newPassword = this.$t("error.validation.length.newPasswordMin");
                            this.valid.newPassword = true;
                        } else if (!validater.checkStringType(this.newPassword)) {
                            this.valid_message.newPassword = this.$t("error.validation.stringtype");
                            this.valid.newPassword = true;
                        } else if (!validater.checkComplexity(this.newPassword)) {
                            this.valid_message.newPassword = this.$t("error.validation.complexity");
                            this.valid.newPassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.newPassword && this.newRePassword) {
                                if (this.newPassword !== this.newRePassword) {
                                    this.valid_message.newPassword = this.$t("error.validation.unmatchPassword");
                                    this.valid.newPassword = true;
                                } else {
                                    this.valid_message.newPassword = "";
                                    this.valid.newPassword = false;
                                    this.valid_message.newRePassword = "";
                                    this.valid.newRePassword = false;
                                }
                            } else {
                                this.valid_message.newPassword = "";
                                this.valid.newPassword = false;
                            }
                        }
                    } else if (event.target.id === "newRePassword") {
                        // 新しいパスワード（確認）チェック
                        if (!validater.checkStringLengthMax(event.target.value, 128)) {
                            this.valid_message.newRePassword = this.$t("error.validation.length.newRePasswordMax");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkStringLengthMin(event.target.value, 8)) {
                            this.valid_message.newRePassword = this.$t("error.validation.length.newRePasswordMin");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkStringType(this.newRePassword)) {
                            this.valid_message.newRePassword = this.$t("error.validation.stringtype");
                            this.valid.newRePassword = true;
                        } else if (!validater.checkComplexity(this.newRePassword)) {
                            this.valid_message.newRePassword = this.$t("error.validation.complexity");
                            this.valid.newRePassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.newPassword && this.newRePassword) {
                                if (this.newPassword !== this.newRePassword) {
                                    this.valid_message.newRePassword = this.$t("error.validation.unmatchPassword");
                                    this.valid.newRePassword = true;
                                } else {
                                    this.valid_message.newPassword = "";
                                    this.valid.newPassword = false;
                                    this.valid_message.newRePassword = "";
                                    this.valid.newRePassword = false;
                                }
                            } else {
                                this.valid_message.newRePassword = "";
                                this.valid.newRePassword = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            }
        },
        /** ----------------------------------------------
         * パスワード登録ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function () {
            if (
                this.newPassword !== "" &&
                this.newRePassword !== "" &&
                this.currentPassword !== "" && // 全フォームに値があり
                this.valid.newPassword === false &&
                this.valid.newRePassword === false &&
                this.valid.currentPassword === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled = false; // ボタン押下可能
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * パスワード変更ボタン押下時処理
         * ---------------------------------------------- */
        submitChangePassword: async function (event) {
            if (this.checkInputData(event)) {
                this.$store.commit("loading/setIsLoading", true);
                try {
                    let res = await this.$apollo.mutate({
                        mutation: UPDATE_MYPAGE_PASSWORD,
                        variables: {
                            old_password: this.currentPassword,
                            password: this.newPassword,
                            password_confirmation: this.newRePassword
                        }
                    });

                    if (res.data.memberUpdatePassword.result === 1) {
                        this.logOut();
                        this.confirmDialogSw = true;
                        this.$store.commit("loading/setIsLoading", false);
                        // this.$router.push({ path: '/mypage-passchange-complete' });
                    } else {
                        this.$store.commit("loading/setIsLoading", false);
                    }
                } catch (error) {
                    if (error.graphQLErrors[0].message == "The given data was invalid.") {
                        this.valid.newPassword = true;
                        this.valid_message.newPassword = this.$t("error.validation.passwordSame");
                    } else {
                        this.valid.currentPassword = true;
                        this.valid_message.currentPassword = error.graphQLErrors[0].message;
                    }

                    this.$store.commit("loading/setIsLoading", false);
                }
            }
        },
        /** ----------------------------------------------
         * パスワード再設定処理
         * ---------------------------------------------- */
        resettingPassBtn: function() {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo
                .mutate({
                    mutation: FORGOT_PASSWORD_MAIL,
                    variables: {
                        email: this.mailReset,
                        family_name: this.familyName,
                        given_name: this.givenName
                    }
                })
                .then(res => {
                    this.logOut();
                    this.mailSendDialogSw = true;
                    this.$store.commit("loading/setIsLoading", false);
                })
                .catch(error => {
                    this.$store.commit("loading/setIsLoading", false);
                    this.err_msg = error.graphQLErrors[0].message;
                    if (this.err_msg == "The given data was invalid.") {
                        this.err_msg = error.graphQLErrors[0].extensions.validation.email[0];
                    }
                });
        },
        /** ----------------------------------------------
         * 戻るボタンの処理 会員情報参照画面へ
         * ---------------------------------------------- */
        gotoMypageInfo: function () {
            this.$router.push({ path: '/mypage-info' });
        },
        /** ----------------------------------------------
         * ログアウト処理
         * ---------------------------------------------- */
        logOut: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        onSignupForm: function () {
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else {
                this.$router.push({ path: '/' });
            }
        }
    }
}

</script>

<style scoped>

.confirm_wording {
    display: table-cell;
    vertical-align: middle;
}

.confirm_table {
    display: table;
}

.confirmDialog{
    margin: 0 20px 0 20px;
    width: 600px;
    background: #ffffff;
    padding: 30px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.dialogContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.btnContainer{
    display: flex;
    justify-content: space-around;
}

.col-btn-size{
    width: 120px;
    word-break: keep-all;
    margin: 1rem;
}

.col-md-btn-size {
    width: 200px;
}

@media screen and (max-width: 896px) {
    .confirmDialog{
        width: initial;
    }

    .confirm_header {
        width: initial;
    }
}

@media screen and (max-width: 575px) {
    .mail-confirm-br {
        display: none;
    }
}
</style>
